export default function Icon() {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 24 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M12.4688 23.0625C12.4688 23.5803 12.0491 24 11.5313 24H0.937501C0.419678 24 0 23.5803 0 23.0625V10.1563C0 9.878 0.123596 9.61415 0.337281 9.43617L11.3998 0.217391C11.7475 -0.0724637 12.2525 -0.0724637 12.6002 0.217391L23.6627 9.43617C24.0604 9.76759 24.1141 10.3586 23.7827 10.7565C23.4513 11.1542 22.86 11.2079 22.4623 10.8765L12 2.15794L1.875 10.5954V22.125H11.5313C12.0491 22.125 12.4688 22.5446 12.4688 23.0625Z"
          fill="#ea580c"
        />
        <path
          d="M18.0003 15.3594C17.074 15.3594 16.3203 16.113 16.3203 17.0394C16.3203 17.9657 17.074 18.7194 18.0003 18.7194C18.9267 18.7194 19.6803 17.9657 19.6803 17.0394C19.6803 16.113 18.9267 15.3594 18.0003 15.3594ZM18.0003 18.012C17.464 18.012 17.0277 17.5757 17.0277 17.0394C17.0277 16.5031 17.464 16.0667 18.0003 16.0667C18.5366 16.0667 18.9729 16.5031 18.9729 17.0394C18.9729 17.5757 18.5366 18.012 18.0003 18.012Z"
          fill="#ea580c"
          stroke="#ea580c"
          strokeWidth="0.48"
        />
        <path
          d="M18.0098 12.4805C15.4897 12.4805 13.4395 14.5307 13.4395 17.0508V17.1771C13.4395 18.4516 14.1702 19.9368 15.6113 21.5914C16.6561 22.7909 17.6862 23.6273 17.7296 23.6623L18.0098 23.8887L18.29 23.6623C18.3333 23.6273 19.3635 22.7909 20.4082 21.5914C21.8493 19.9368 22.5801 18.4517 22.5801 17.1771V17.0508C22.5801 14.5307 20.5298 12.4805 18.0098 12.4805ZM21.6883 17.1771C21.6883 19.331 18.9131 21.9383 18.0098 22.7298C17.1062 21.9381 14.3312 19.3308 14.3312 17.1771V17.0508C14.3312 15.0225 15.9814 13.3722 18.0098 13.3722C20.0381 13.3722 21.6883 15.0225 21.6883 17.0508V17.1771Z"
          fill="#ea580c"
          stroke="#ea580c"
          strokeWidth="0.96"
        />
      </g>
    </svg>
  );
}
